import { Chart as ChartJS, Plugin } from "chart.js";

/**
 * O app aplica `zoom` CSS no #root (globalStyles.css). O Chart.js calcula a
 * posição do mouse misturando coordenadas visuais (clientX / rect) com o
 * tamanho de layout do canvas, então o hover/tooltip caía em outro dia/hora.
 * Recalcula x/y do evento usando a proporção real entre layout e visual.
 */
const chartZoomFixPlugin: Plugin = {
  id: "appZoomEventFix",
  beforeEvent(chart, args) {
    const event = args.event as { x: number | null; y: number | null; native: Event | null };
    const native = event.native as (MouseEvent & TouchEvent) | null;
    if (!native || !chart.canvas) return;

    const point =
      native.touches?.[0] ?? native.changedTouches?.[0] ?? (native as MouseEvent);
    if (point?.clientX === undefined) return;

    const rect = chart.canvas.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    event.x = ((point.clientX - rect.left) * chart.width) / rect.width;
    event.y = ((point.clientY - rect.top) * chart.height) / rect.height;
  },
};

ChartJS.register(chartZoomFixPlugin);
